<div class="dialog-box">
  @if (!isCustom) {
    <div class="dialog-box__header">
      <button mat-icon-button mat-dialog-close tabindex="-1">
        <mat-icon aria-hidden="true">close</mat-icon>
      </button>
    </div>
    <div class="dialog-box__content">
      <div class="title">{{ title | translate }}</div>
      <div class="error-dialog">
        @if (!understandButton && httpResponseMessage) {
          <div class="error-dialog__message" [innerHTML]="httpResponseMessage"></div>
        }
        @if (!understandButton) {
          <div class="error-dialog__message" [innerHTML]="message"></div>
        }
        @if (understandButton) {
          <div class="error-dialog__message" [innerHTML]="message | translate"></div>
        }
        @if (showEmail) {
          <div class="error-dialog__mailto"><a href="mailto:support@taxando.de">support&#64;taxando.de</a></div>
        }
        @if (!understandButton && !noErrorButton) {
          @if (!endpoint) {
            <div class="error-dialog__buttons">
              <a href="mailto:support@taxando.de">
                <button class="btn btn--primary btn--longer">
                  {{ "ERROR_MODAL_SUMMARY.SEND_INFO_EMAIL" | translate }}
                </button>
              </a>
            </div>
          }
          @if (endpoint) {
            <div class="error-dialog__buttons">
              <button class="btn btn--primary btn--longer" mat-dialog-close>
                {{ "ERROR_MODAL_SUMMARY.GO_TO_ERROR_COMPONENT" | translate }}
              </button>
            </div>
          }
        }
        @if (understandButton) {
          <div class="error-dialog__buttons">
            <button id="closeErrorPopup" class="btn btn--primary btn--longer" mat-dialog-close>
              {{ "REISTER_ERROR.UNDERSTAND" | translate }}
            </button>
          </div>
        }
        @if (noErrorButton) {
          <div class="error-dialog__buttons">
            <button id="closeErrorPopup" class="btn btn--primary btn--longer" mat-dialog-close>
              {{ "COMMON.OK" | translate }}
            </button>
          </div>
        }
      </div>
    </div>
  }
  @if (isCustom) {
    <div class="dialog-box__custom_wrap">
      <div class="dialog-box__header">
        <button mat-icon-button mat-dialog-close tabindex="-1">
          <mat-icon aria-hidden="true">close</mat-icon>
        </button>
      </div>
      <div class="dialog-box__content">
        <div class="dialog-box__custom" [class.error]="endpoint">
          <div class="lhs">
            <div class="title">{{ "ERROR_MODAL_SUMMARY.TITLE" | translate }}</div>
            <div class="desc">
              @if (!endpoint) {
                {{ message | translate }}
                <a href="mailto:{{ 'ERROR_MODAL_SUMMARY.EMAIL' | translate }}">
                  {{ "ERROR_MODAL_SUMMARY.EMAIL" | translate }}
                </a>
              }
              @if (endpoint) {
                <div class="error">{{ message }}</div>
              }
            </div>
            <div class="btns_wrap" [class.error]="endpoint">
              @if (!endpoint) {
                <div class="single_btn">
                  <button class="btn btn--longer btn--small red" mat-dialog-close>
                    {{ "ERROR_MODAL_SUMMARY.IGNORE_BUTTON" | translate }}
                  </button>
                </div>
                <div class="single_btn">
                  <a href="mailto:support@taxando.de">support&#64;taxando.de</a>
                  <button class="btn btn--primary btn--longer" (click)="submitAction()" mat-dialog-close>
                    {{ "ERROR_MODAL_SUMMARY.SEND_INFO_EMAIL" | translate }}
                  </button>
                </div>
              }
              @if (endpoint) {
                <div class="single_btn">
                  <button class="btn btn--longer btn--small red" mat-dialog-close i18n>
                    {{ "ERROR_MODAL_SUMMARY.IGNORE_BUTTON" | translate }}
                  </button>
                </div>
                <div class="single_btn">
                  <button class="btn btn--primary is_icon" (click)="submitAction()" mat-dialog-close i18n>
                    <img class="btn_icon" src="../../../assets/img/edit_icon_taxando_error.png" alt="Button icon" />
                    {{ "ERROR_MODAL_SUMMARY.GO_TO_ERROR_COMPONENT" | translate }}
                  </button>
                </div>
              }
            </div>
          </div>
          <div class="rhs">
            <picture>
              <img class="dialog_icon" src="../../../assets/img/graphic_taxando_error.png" alt="Dialog icon" />
            </picture>
          </div>
        </div>
      </div>
    </div>
  }
</div>
